import {Injectable} from "@angular/core";
import {CoreErrorHandlerBaseService} from "@core/services/error-handler-base/core-error-handler-base.service";
import {IAlertControllerCreate} from "@shared/interfaces/alert-controller-create.interface";

@Injectable({
  providedIn: 'root'
})
export class TeamErrorHandlerGuestLoginTeamCodeService extends CoreErrorHandlerBaseService {

  override _formatAlertFor404(status: number): IAlertControllerCreate {
    this._errorText = this._translateService.instant("TEAM.WELCOME.ERRORS.DESCRIPTIONS.UNKNOWN_CODE");
    return {
      header: this._translateService.instant("TEAM.WELCOME.ERRORS.TITLES.UNKNOWN_CODE"),
      subHeader: '',
      message: this._translateService.instant("TEAM.WELCOME.ERRORS.DESCRIPTIONS.UNKNOWN_CODE"),
      buttons: [
        { text: this._translateService.instant("TEAM.WELCOME.BUTTONS.OK") }
      ]
    };
  }
}
